import { useMemo } from "react";
import { useLocation } from "react-router";
import {
  CUSTOMER_WEBSITE_ROUTE,
  WEBSITE_BASE_TAB_ROUTE
} from "../components/strings";

const getRouteInfo = (pathname = "") => {
  // remove trailing slash (if any)
  const trailingForwardSlashRegex = /\/$/;
  const normalized = pathname.replace(trailingForwardSlashRegex, "");
  const last = normalized.split("/").pop();
  const isBaseWebsite = last === CUSTOMER_WEBSITE_ROUTE;
  return {
    tabRoute: isBaseWebsite ? WEBSITE_BASE_TAB_ROUTE : `/${last}`,
    tabLabel: isBaseWebsite ? "Base Website" : last
  };
};

export const useTabRoute = () => {
  const { pathname } = useLocation();
  return useMemo(() => {
    return getRouteInfo(pathname);
  }, [pathname]);
};
